import { organizationSchema } from "./schema";

/**
 * Rendered directly in the root <head>, not via a `meta` export.
 *
 * In Remix v2 a child route's `meta` replaces its parent's entirely, so
 * anything returned from root.meta is discarded on every route that defines its
 * own. Emitting the site-wide graph here guarantees it appears on every page.
 */
export default function OrganizationSchema() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(organizationSchema()),
      }}
    />
  );
}
